import React from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'
import { Switch } from 'react-router-dom'
import { GameHome, GameRoom, GameMenu } from '.'
import { CustomizedSnackbar } from '../../../containers'
import { MenuAppBar } from '../../../Parts/MenuAppBar'
import { LANGUAGE_SHORT_CODE } from '../../../constants'
import { WID } from '../../../constants/Language'
import Word from '../../../containers/Common/Word'
import { GameProvider } from '../GameProvider'
import RequestPasswordDialog from '../components/RequestPasswordDialog'
import NewGameSettingsDialog from './NewGameSettingsDialog'

const mapStateToProps = (state, ownProps) => {
  return ({
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

const GameRouting = (props) => {
  var regstr = Object.keys(LANGUAGE_SHORT_CODE).map(key => LANGUAGE_SHORT_CODE[key]).join('|')

  return (
    <GameProvider>
      <MenuAppBar title={<Word wid={WID.MENU_APP_BAR.ONLINE_GAME}/>} actions={<GameMenu/>}/>
      <Switch>
        <Route exact path='/game' component={GameHome} />
        <Route path='/game/:group/:room' component={GameRoom} />
        <Route exact path={`/:language(${regstr})/game`} component={GameHome}/>
        <Route path={`/:language(${regstr})/game/:group/:room`} component={GameRoom}/>
      </Switch>
      <CustomizedSnackbar/>
      <RequestPasswordDialog/>
      <NewGameSettingsDialog/>
    </GameProvider>
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GameRouting)




// WEBPACK FOOTER //
// ./src/Pages/Game/containers/GameRouting.js